export default __webpack_public_path__ + "6bd89e7ce241d147c923acd88b0db1bf.png";